import { render, staticRenderFns } from "./VehiclePrimaryUseType.vue?vue&type=template&id=4a659752&"
import script from "./VehiclePrimaryUseType.vue?vue&type=script&lang=js&"
export * from "./VehiclePrimaryUseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports